<template>
  <el-row class="container">
    <!--头部-->
    <el-col :span="24"
            class="topbar-wrap">
      <div class="topbar-logo topbar-btn"
           @click="test">
        <a href="/">
          <img src="@/assets/nav-logo.png"
               class="logo">
        </a>
      </div>
      <div class="topbar-logos">

      </div>
      <div class="topbar-title">
        <!-- 注意：这里就是topNavState作用之处，根据当前路由所在根路由的type值判断显示不同顶部导航菜单 -->
        <el-row>
          <el-col :span="24">
            <el-menu :default-active="defaultActiveIndex"
                     class="el-menu-demo"
                     mode="horizontal"
                     @select="handleSelect"
                     :router="false">
              <!-- <el-menu-item index="index">首页</el-menu-item>
              <el-menu-item index="organizationManage">组织管理</el-menu-item>
              <el-menu-item index="subSystemManage">系统管理</el-menu-item>
              <el-menu-item index="resourceManage">资源管理</el-menu-item>
              <el-menu-item index="settingManage">配置管理</el-menu-item>
              <el-menu-item index="accessManage">服务管理</el-menu-item> -->
              <el-menu-item v-for="(item, index) in roleInfo.topNav"
                            :class="item.active?'active':'11'"
                            :key="index"
                            :index="item.menu_id">{{item.menu_name}}</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="topbar-account topbar-btn">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link userinfo-inner">
            <i class="iconfont icon-user"></i> {{userInfo.user_name}}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item>
              <div>
                <span style="color: #555;font-size: 14px;">个人信息</span>
              </div>
            </el-dropdown-item> -->
            <el-dropdown-item>
            </el-dropdown-item>
            <el-dropdown-item @click.native="openDialog">

              <div>
                <span style="color: #555;font-size: 14px;">修改密码</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
    <!-- 修改密码弹窗 -->
    <el-dialog :visible.sync="changePswFormVisible"
               :close-on-click-modal="false"
               @close="closeDialog"
               width="35%">
      <el-form :model="ruleForm"
               ref="ruleForm"
               :rules="rules"
               status-icon
               label-width="80px">
        <el-form-item label="原密码"
                      prop="old_password">
          <el-input v-model="ruleForm.old_password"
                    type="password"
                    class="password-input"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码"
                      prop="password">
          <el-input v-model="ruleForm.password"
                    class="password-input"
                    type="password"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="confirm_password">
          <el-input v-model="ruleForm.confirm_password"
                    type="password"
                    class="password-input"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="changePswFormVisible = false,clearPass('ruleForm')">取 消</el-button>
        <el-button type="primary"
                   @click="changePsw('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import { loginApi } from '@/services/Login'
export default {
  data () {
    let checkOldPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入原密码'))
      } else {
        callback()
      }
    }
    let checkPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    let checkPassAgain = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      defaultActiveIndex: '/',
      userInfo: {},
      changePswFormVisible: false,
      showBtn: true,
      ruleForm: {
        old_password: '',
        password: '',
        confirm_password: ''
      },
      rules: {
        old_password: [
          { validator: checkOldPass, trigger: 'blur' }
        ],
        password: [
          { validator: checkPass, trigger: 'blur' }
        ],
        confirm_password: [
          { validator: checkPassAgain, trigger: 'blur' }
        ]
      },
      navList: {}
    }
  },
  watch: {
    roleInfo: {
      handler (newval, oldval) {
        if (newval.topNav) {
          this.navList = newval
        }
        // console.log(this.navList, this.roleInfo, '00000')
      },
      deep: true
    }
  },
  computed: {
    roleInfo () {
      let store = this.$store.state.roleInfo
      let local = JSON.parse(window.localStorage.getItem('roleInfo')) || {}
      let role = store || local

      return role
    }

  },
  created () {
    this.userInfo = JSON.parse(window.localStorage.userInfo)
  },
  methods: {
    handleSelect (key, keyPath) {
      let activeNav = this.roleInfo.nav[key]
      if (activeNav) {
        this.$store.dispatch('sideNav', activeNav)
        window.localStorage.setItem('sideNav', JSON.stringify(activeNav))
      }
    },
    test (e) {
      e.preventDefault()
      this.roleInfo.topNav[3].active = true
    },
    // 退出登录
    logout () {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        loginApi.logout({
        }).then(res => {
          if (res.msg === 'SUCCESS') {
            this.$message({
              type: 'success',
              message: '已退出登录!'
            });
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('user_id')
            window.localStorage.removeItem('userInfo')
            this.$router.push('./login')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    },
    openDialog () {
      this.changePswFormVisible = true
    },
    // 修改密码
    changePsw (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          loginApi.changePass({
            data: {
              old_password: this.ruleForm.old_password,
              user_id: window.localStorage.getItem('user_id'),
              password: this.ruleForm.password,
              confirm_password: this.ruleForm.confirm_password
            }
          }).then(res => {
            if (res.msg === 'SUCCESS') {
              this.$message({
                type: 'success',
                message: '修改成功，请重新登录!'
              });
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('user_id')
              window.localStorage.removeItem('userInfo')
              this.$router.push('./login')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 清除密码
    clearPass (ruleForm) {
      this.$refs[ruleForm].resetFields()
    },
    // 修改密码对话框关闭回调
    closeDialog () {
      this.clearPass('ruleForm')
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .password-input {
  width: 80%;
}
/deep/ .password-code {
  width: 48%;
}
/deep/ .change-btn {
  width: 31%;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/topNav.vue